import cx from 'classnames'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useCountDown, useScroll } from 'hooks'
import { snowplowEvent } from 'lib/analytics'
import { SessionStorage } from 'lib/storage'
import {
  useCreateHimanowMutation,
  useGetHimanowUsersQuery,
} from 'store/api/yay/user'

import { HimanowUserList } from 'components'

import './style.scss'

const DISABLE_HIMANOW_IN_SEC = 30

export const HimanowListBox = () => {
  const { t } = useTranslation()
  const ref = useRef<HTMLDivElement>(null)
  const { diff } = useScroll({ target: ref })

  const himanowUsersRes = useGetHimanowUsersQuery({})

  const [createHimanow, createHimanowRes] = useCreateHimanowMutation()

  const { count, startCountDown, stopCountDown } = useCountDown(
    DISABLE_HIMANOW_IN_SEC,
    200
  )

  const onCreateHimanow = () => {
    createHimanow({}).then((res: any) => {
      if (res?.['data']?.result == 'success') {
        snowplowEvent.activate_himanow()
        SessionStorage.himanowTimestamp.set(Date.now())
        startCountDown()
      }
    })
  }

  useEffect(() => {
    const lastHima = +SessionStorage.himanowTimestamp.get(0)

    if (lastHima) {
      const diff = lastHima + DISABLE_HIMANOW_IN_SEC * 1000 - Date.now()
      if (diff > 0) startCountDown(diff / 1000)
    }

    return () => {
      if (count > 0) {
        stopCountDown()
      }
    }
  }, [])

  useEffect(() => {
    if (count !== null && count <= 0) {
      SessionStorage.himanowTimestamp.remove()
    }
  }, [count])

  useEffect(() => {
    snowplowEvent.scroll({ diff })
  }, [diff])

  return (
    <div className="HimanowListBox">
      <div className="HimanowListBox__create">
        {(() => {
          const percentGradient = (100 * count) / DISABLE_HIMANOW_IN_SEC

          const shouldDisableCreateHimanow =
            count !== null || createHimanowRes?.isLoading

          return (
            <div
              role="button"
              onClick={shouldDisableCreateHimanow ? undefined : onCreateHimanow}
            >
              <div
                className={cx('HimanowListBox__create__icon_wrapper', {
                  'HimanowListBox__create__icon_wrapper--disabled':
                    shouldDisableCreateHimanow,
                })}
                style={{
                  background: `linear-gradient(to top, var(--c-primary) 0%, var(--c-primary) ${percentGradient}%, var(--c-gray-12) ${percentGradient}%, var(--c-gray-12) 100%)`,
                }}
              >
                <div className="HimanowListBox__create__icon" />
              </div>

              <div className="HimanowListBox__create__text">
                {t('himanow_list_box.himanow')}
              </div>
            </div>
          )
        })()}
      </div>

      <HimanowUserList
        users={(himanowUsersRes?.data ?? []).slice(0, 8)}
        mode="scroll"
        showBio={false}
        listRef={ref}
      />
    </div>
  )
}
